import Feedback from "./views/Feedback.vue";
import FeedbackCard from "./components/FeedbackCard.vue";
import FeedbackDocument from "./components/FeedbackDocument.vue";
import Auth from "@kinetics254/cassandra-base/modules/auth/middleware/Auth";

export default [
  {
    path: "/feedback",
    component: Feedback,
    children: [
      {
        path: "",
        redirect: "/feedback/feedback-card/:code/:docNo/:reference",
      },
      {
        path: "feedback-card/:code/:docNo/:reference",
        name: "FeedbackCard",
        component: FeedbackCard,
        meta: { middleware: [Auth] },
      },
      {
        path: "feedback-document/:code/:docNo/:reference",
        name: "FeedbackDocument",
        component: FeedbackDocument,
        meta: { middleware: [Auth] },
      },
    ],
  },
];
